/**
 * Console logging with a consistent prefix. Never pass form contents or other personal data.
 */
const PREFIX = '[ReTax360]';

export const logger = {
  warn(message: string, error?: unknown): void {
    console.warn(PREFIX, message, ...(error === undefined ? [] : [describeError(error)]));
  },
  error(message: string, error?: unknown): void {
    console.error(PREFIX, message, ...(error === undefined ? [] : [describeError(error)]));
  },
};

function describeError(error: unknown): string {
  return error instanceof Error ? `${error.name}: ${error.message}` : String(error);
}
